import Model, { attr } from '@ember-data/model';

export default class JournalTemplateModel extends Model {
  @attr('string') declare name: string;
  @attr('string') fundGroupId?: string;
  @attr('number') declare mainGoalTypeId: number;
  @attr('boolean') declare canHaveSecondaryOneTimeGoal: boolean;
  @attr() stages: any;
  @attr('boolean') declare canOverrideStages: boolean;
  @attr('boolean') declare decisionsRequireGift: boolean;
  @attr('boolean') declare hideDecisionsRequireGift: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'journal-template': JournalTemplateModel;
  }
}
